"use client";

import { motion } from "framer-motion";
import { socials } from "../constants";

import styles from "../styles";
import { footerVariants } from "../utils/motion";

const Footer = () => (
  <motion.footer
    variants={footerVariants}
    initial="hidden"
    whileInView="show"
    className={`${styles.xPaddings} py-8 relative`}
  >
    <div className="footer-gradient" />
    <div className={`${styles.innerWidth} mx-auto flex flex-col gap-8`}>
      <div className="flex flex-col">
        <div className="mb-[50px] h-[2px] bg-white opacity-10" />

        <div className="flex items-center justify-between flex-wrap gap-4">
          <h4 className="font-extrabold text-[24px] text-white">DNAU</h4>
          <p className="font-normal text-[14px] text-white opacity-50">
            Copyright © 2022 - 2024 DNA Universe. All rights reserved.
          </p>
          <div className="flex flex-col items-end gap-4">
            <div className="flex gap-4">
              {socials.map((social) => (
                <img
                  key={social.name}
                  src={social.url}
                  alt={social.name}
                  className="w-[24px] h-[24px] object-contain cursor-pointer"
                  onClick={() => window.open(social.link, "_blank")}
                />
              ))}
            </div>
            <p className="font-normal text-[14px] text-white opacity-50">
              Contact in{" "}
              <a href="mailto:hello@dnau.com.co">hello@dnau.com.co</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </motion.footer>
);

export default Footer;
